/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { Divider, Grid, Link, Typography } from '@mui/material';
import voca from 'voca';

import { useAuthContext } from 'src/auth/hooks';
import Hero from '../assets/ocdfeat-hero-1.svg';
import { ReportSummaryCard } from '../components/ReportSummaryCard';
import { QuickLinks } from '../components/QuickLinks';
import { useApiRepo, Endpoints } from '../utils/Api';
import squiggle from '../assets/squiggle.jpeg';
import { Colors } from '../utils/Colors';

interface ReportSummaryItem {
  aggregate: string;
  aggregate_date: string;
  response_type: string;
  response_name: string;
  sum: number;
}

export function Dashboard() {
  const { user } = useAuthContext();
  const { getObjectsFromAPI } = useApiRepo();

  const [reportData, setReportData] = useState([]);
  const [resistRate, setResistRate] = useState(0);
  // const [challengeRate, setChallengeRate] = useState(0);
  const [lastSurveyScore, setLastSurveyScore] = useState(0);
  const [avgSurveyScore, setAvgSurveyScore] = useState(0);

  useEffect(() => {
    const fetchReportData = async () => {
      const api = await getObjectsFromAPI();
      const res = await api.get(Endpoints.banBookReportSummary);

      const resistRateResponse = await api.get(Endpoints.resitsRate);
      // const challengeRateResponse = await api.get(Endpoints.challengeRate);
      const lastSurveyResponse = await api.get(Endpoints.surveyLast);
      const averageSurveyResponse = await api.get(Endpoints.surveyAverage);

      setReportData(res.data.data);
      setResistRate(resistRateResponse.data.data.resist_rate);
      // setChallengeRate(challengeRateResponse.data.data.challenge_rate);
      setLastSurveyScore(lastSurveyResponse.data.data[0].score);
      setAvgSurveyScore(averageSurveyResponse.data.data[0].avgerage_score);
    };
    fetchReportData();
  }, []);

  const titleStyle = {
    fontSize: '36px',
    color: Colors.richBlack,
    marginBottom: '30px'
  };

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      style={{ padding: '50px 0', width: '90vw', margin: 'auto' }}
    >
      <Grid item xs={12}>
        <Typography align="left" style={{ fontSize: '36px' }}>
          Hello,&nbsp;{voca.capitalize(user?.first?.trim())}!
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ minHeight: '15px' }}>
        <Divider variant="middle" />
      </Grid>
      <Grid item xs={12} lg={7}>
        <Typography variant="h3" style={titleStyle}>
          Today&apos;s Results
        </Typography>
        <Grid item style={{ padding: '40px 0px 40px' }}>
          <img src={squiggle} alt="divderImage" style={{ height: '15px' }} />
        </Grid>
        <Grid
          container
          item
          direction="row"
          spacing={2}
          style={{ padding: '20px' }}
        >
          {reportData.map((item: ReportSummaryItem) => (
            <Grid item key={item.response_type}>
              <ReportSummaryCard
                title={item.response_name}
                value={String(item.sum)}
              />
            </Grid>
          ))}
        </Grid>
        <Grid
          container
          item
          direction="row"
          spacing={2}
          style={{ padding: '20px' }}
        >
          <Grid item>
            <ReportSummaryCard
              grey
              title="Resist Rate"
              value={`${(resistRate * 100).toFixed(1)}%`}
            />
          </Grid>
          {/* <Grid item>
            <ReportSummaryCard
              grey
              title="Challenge Rate"
              value={`${(challengeRate * 100).toFixed(1)}%`}
            />
          </Grid> */}
          <Grid item>
            <ReportSummaryCard
              grey
              title="Anxiety Survey:  Last Score"
              value={String(lastSurveyScore ?? 0)}
            />
          </Grid>
          <Grid item>
            <ReportSummaryCard
              grey
              title="Anxiety Survey: 4-Week Avg"
              value={avgSurveyScore?.toFixed(1) ?? 0}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        item
        xs={12}
        lg={5}
        sx={{ display: { xs: 'none', lg: 'cover' } }}
      >
        <img src={Hero} alt="hero" style={{ height: '475px', width: '100%' }} />
        <Typography
          fontWeight="semibold"
          fontStyle="italic"
          variant="h6"
          align="left"
          color={Colors.skobeloff}
          style={{
            marginTop: '25px',
            padding: '25px',
            whiteSpace: 'pre-line',
            borderLeft: `3px solid ${Colors.ocdGreen}`
          }}
          component="div"
        >
          Anything is possible if you put your mind to it. Even if it&#39;s a
          hard exposure or a fear of yours. Anything is possible -- even
          controlling your OCD and anxiety so it cant bug you anymore.
          {'\n'}
          <Typography
            fontWeight="bold"
            variant="h6"
            fontStyle="normal"
            color={Colors.richBlack}
            paddingTop="20px"
          >
            Dexter, Age 9
          </Typography>
        </Typography>
      </Grid>
      <QuickLinks />
      <Grid item xs={12}>
        <Typography align="left">We&apos;d love to hear from you!</Typography>
        <Typography align="left">
          For help with OCDfeat, or to tell us what&apos;s working and how we
          can improve, please contact us at{' '}
          <Link href="mailto:support@ocdfeat.com">support@ocdfeat.com</Link>.
        </Typography>
      </Grid>
    </Grid>
  );
}
